import React from "react";
import PropTypes from "prop-types";
import { ListItem, ListItemText } from "@material-ui/core";
// import breadcrumbNameMap from '../../helpers/breadcrumbNameMap';
import { NavLink } from "react-router-dom";

const ListItemLink = props => {
  const { to, ...other } = props;
  return (
    <ListItem button component={NavLink} to={to} {...other}>
      {props.children}
      <ListItemText />
    </ListItem>
  );
};

ListItemLink.propTypes = {
  to: PropTypes.string.isRequired
};

export default ListItemLink;
